import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    toggleFilterWeb,
    togglePrizeBoxWeb,
    resetAllFilters,
} from './../../../actions/FilterActions';
import SearchBtnMobile from './SearchBtnMobile';
import common from '../../../common';

class FilterHeaderWeb extends Component {
    onFilterTapToExpand = () => {
        this.props.toggleFilterWeb();
    };
    onResetFilter = () => {
        this.props.resetFilter();
    };
    onPriceTapToExpand = () => {
        this.props.togglePrizeBoxWeb();
    };

    render() {
        const { isFilterOpenForWeb, filterCount, priceFilterSelected, isPriceBoxOpenForWeb, isSearchOpenForBoth } = this.props;
        const isSIActive = filterCount > 0 && isFilterOpenForWeb;
        const countIconClassDesktop = common.makeClasses({
            'icon-ucl-console': true,
            'si-filter-icons': true,
            'si-display-none': filterCount,
        });
        const priceOptionClass = common.makeClasses({
            'si-filter-item': true,
            'si-price-opt': true,
            'si-display-none': isFilterOpenForWeb,
            'si-active': !isPriceBoxOpenForWeb && priceFilterSelected.length
        });
        const filterCountClass = common.makeClasses({
            'si-filter-count': true,
            'si-display-none': filterCount === 0,
        });
        const filterClass = common.makeClasses({
            'si-filter-item': true,
            'si-filter-opt': true,
            'si-active': isSIActive
        });
        const handler = isPriceBoxOpenForWeb ? () => {
        } : () => this.onPriceTapToExpand();
        return <div className="si-filter-wrap si-web">
            <div className="si-option-wrap">
                { !isSearchOpenForBoth ? <div className={ filterClass }
                    onClick={ () => this.onFilterTapToExpand() }>
                    <i className={ countIconClassDesktop } />
                    <div className={ filterCountClass }>{ filterCount }</div>
                    <span>{ this.props.trans.filters }</span>
                </div> : null }

                {/* {!isSearchOpenForBoth ? <div className={priceOptionClass}
                    onClick={handler}>
                    <span className="si-filter-icons">€</span>
                    <span>{this.props.trans.price}</span>
                </div> : null} */}
            </div>
            <SearchBtnMobile toScrollToTop={ () => this.props.toScrollToTop() } />
            { filterCount > 0 ?
                <div className="si-filter-item si-price-opt" onClick={ () => this.onResetFilter() }>
                    <span>{ this.props.trans.reset }</span>
                </div> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        filterCount: state.formationData.playerFilters.filterCount,
        isFilterOpenForWeb: state.formationData.isFilterOpenForWeb,
        isPriceBoxOpenForWeb: state.formationData.isPriceBoxOpenForWeb,
        isSearchOpenForBoth: state.formationData.isSearchOpenForBoth,
        priceFilterSelected: state.formationData.playerFilters.priceFilterSelected,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleFilterWeb: (bool) => dispatch(toggleFilterWeb()),
        togglePrizeBoxWeb: (bool) => dispatch(togglePrizeBoxWeb()),
        resetFilter: (bool) => dispatch(resetAllFilters()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterHeaderWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/FilterHeaderWeb.js